import React from 'react'
import Category from '../../components/category/Category'
import Blog from '../../components/blog/Blog'
import Footer from '../../components/footer/Footer'


const Home = () => {
    return (
        <>
            <Category />
            <Blog />
            <Footer />
        </>
    )
}

export default Home
